import { AppModule } from '../../types';

export const AdminModule: AppModule = {
  id: 'admin',
  title: 'Administración',
  basePath: 'admin',
};
